import React, { Component } from 'react';
import { toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge } from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';
import ReactToPrint from 'react-to-print';

class DispatchNote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dispatch: {
                itemList: []
            },
            incentiveList: []
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        
    }



    async componentWillMount() {

        let params = this.props.location.search
        let response = await this.dl.Get("/common/getdispatchnotedetail" + params);
        let incentiveResponse = await this.dl.Get("/common/getIncentiveDispatchDetail" + params);
        this.setState({
            dispatch: response.data,
            incentiveList: incentiveResponse.data
        })
        this.props.loaderOff();
    }

    render() {
        return (
            <div>
                <MDBRow>
                    <MDBCol>
                        <MDBBtn rounded color="purple" size="sm" onClick={this.props.history.goBack}>Back</MDBBtn>
                        </MDBCol>
                    <MDBCol className="text-right">
                        <ReactToPrint
                            trigger={() => <MDBBtn rounded color="purple" size="sm">Print</MDBBtn>}
                            content={() => this.componentRef}
                        />
                    </MDBCol>
                </MDBRow>
                <div ref={el => (this.componentRef = el)}>
                    
                        <MDBCard className="card-body">

                            <MDBCardText>
                                <MDBRow className="mx-2">
                                    <MDBCol sm="12">
                                        <span>Dispatch NO:&nbsp;
                                        <span style={{ color: Colors.plum, fontWeight: "Bold" }}>{this.state.dispatch.sfInvoiceDispatchNoteId}</span></span><br /><br />
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow className="mx-2">
                                    <MDBCol md="6" sm="12">
                                        <span style={{ fontSize: "14px" }}>
                                        Invoice Number:&nbsp;<strong>{this.state.dispatch.sfInvoiceId}</strong><br />
                                        Date Processed:&nbsp;{this.state.dispatch.processedDate}<br />
                                        Demonstrator:&nbsp;{this.state.dispatch.demonstrator}<br />
                                        Cell No:&nbsp;{this.state.dispatch.telephoneCell}<br />
                                        Unit:&nbsp;{this.state.dispatch.unitName}<br />
                                        </span>
                                    </MDBCol>
                                    <MDBCol md="6" sm="12">
                                        <span style={{ fontSize: "14px" }}>
                                        Pick List No:&nbsp;<strong>{this.state.dispatch.sfInvoicePickListId}</strong><br />
                                        Warehouse:&nbsp;{this.state.dispatch.warehouse}<br />
                                        Dispatch Area:&nbsp;{this.state.dispatch.area}<br />
                                        Dispatched By:&nbsp;{this.state.dispatch.dispatchedBy}<br />
                                       
                                        </span>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCardText>
                        </MDBCard>
                    
                    <MDBRow>
                        <MDBCol>
                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                <div style={{marginRight: "100px", marginBottom: "10px", fontWeight: "bold"}}>On Order</div>
                                {
                                    this.state.dispatch.itemList.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <MDBRow className="mx-2" between>
                                                    {/*<MDBCol>
                                                    <img src="https://mdbootstrap.com/img/Others/documentation/1.jpg" className="img-fluid" alt="" />
                                                </MDBCol>*/}
                                                    <MDBCol >
                                                        <span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.processingCode}:&nbsp;{item.invoiceDescription}</span><br />
                                                        <MDBRow>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <span style={{ fontSize: "14px" }}>Inv Qty:&nbsp;{item.invQty}</span>
                                                            </MDBCol>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <span style={{ fontSize: "14px" }}>Qty Collected:&nbsp;{item.collectionQty}</span>
                                                            </MDBCol>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <span style={{ fontSize: "14px" }}>Prev.Refunds:&nbsp;{item.refundQty}</span>
                                                            </MDBCol>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <span style={{ fontSize: "14px" }}>Prev. Collected:&nbsp;{item.prevColl}</span>
                                                            </MDBCol>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <span style={{ fontSize: "14px" }}>Outstanding:&nbsp;{item.outStandingQty}</span>
                                                            </MDBCol>
                                                        </MDBRow>

                                                    </MDBCol>

                                                </MDBRow><hr className="hr_grey" />

                                            </div>
                                        );
                                    })
                                }
                            </MDBCard>
                        </MDBCol>

                    </MDBRow>

                    {this.state.incentiveList.length > 0 ? <MDBRow>
                        <MDBCol>
                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                <div style={{ marginRight: "100px", marginBottom: "10px", fontWeight: "bold" }}>Incentives</div>
                                {
                                    this.state.incentiveList.map((item, index) => {
                                        return (
                                            <div key={item.sfIncentivesId}>
                                                <MDBRow className="mx-2" between>
                                                    {/*<MDBCol>
                                                    <img src="https://mdbootstrap.com/img/Others/documentation/1.jpg" className="img-fluid" alt="" />
                                                </MDBCol>*/}
                                                    <MDBCol >
                                                        <span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.resultAreaDescription}:&nbsp;{item.invoiceDescription}</span><br />
                                                        <MDBRow>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <span style={{ fontSize: "14px" }}>Qty Dispatched:&nbsp;{item.dispatchedQty}</span>
                                                            </MDBCol>

                                                        </MDBRow>

                                                    </MDBCol>

                                                </MDBRow><hr className="hr_grey" />
                                            </div>
                                        );
                                    })
                                }
                            </MDBCard>
                        </MDBCol>

                    </MDBRow> : <div></div>}
                    
                </div>
            </div>
        )
    }
}

export default DispatchNote;